/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TextAlignCenterJustifyIcon16Light } from './TextAlignCenterJustifyIcon16Light';
import { TextAlignCenterJustifyIcon16Regular } from './TextAlignCenterJustifyIcon16Regular';
import { TextAlignCenterJustifyIcon16Solid } from './TextAlignCenterJustifyIcon16Solid';
import { TextAlignCenterJustifyIcon20Light } from './TextAlignCenterJustifyIcon20Light';
import { TextAlignCenterJustifyIcon20Regular } from './TextAlignCenterJustifyIcon20Regular';
import { TextAlignCenterJustifyIcon20Solid } from './TextAlignCenterJustifyIcon20Solid';
import { TextAlignCenterJustifyIcon24Regular } from './TextAlignCenterJustifyIcon24Regular';
import { TextAlignCenterJustifyIcon24Solid } from './TextAlignCenterJustifyIcon24Solid';
import { TextAlignCenterJustifyIcon32Regular } from './TextAlignCenterJustifyIcon32Regular';
import { TextAlignCenterJustifyIcon64Regular } from './TextAlignCenterJustifyIcon64Regular';
var sizes = {
    16: {
        light: TextAlignCenterJustifyIcon16Light,
        regular: TextAlignCenterJustifyIcon16Regular,
        solid: TextAlignCenterJustifyIcon16Solid,
    },
    20: {
        light: TextAlignCenterJustifyIcon20Light,
        regular: TextAlignCenterJustifyIcon20Regular,
        solid: TextAlignCenterJustifyIcon20Solid,
    },
    24: {
        regular: TextAlignCenterJustifyIcon24Regular,
        solid: TextAlignCenterJustifyIcon24Solid,
    },
    32: {
        regular: TextAlignCenterJustifyIcon32Regular,
    },
    64: {
        regular: TextAlignCenterJustifyIcon64Regular,
    },
};
export var TextAlignCenterJustifyIcon = forwardRef('TextAlignCenterJustifyIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
